import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { routeTo } from 'transfer/utils/routeHelper'
import { paymentTypeUrlMap } from '../../index'
import {
  trackClickUnifiedSend,
  trackGuestReturnToPagePmtChoice,
} from '../../../../../utils/unified-send-analytics'
import { tracking } from '../../../../../../lib/analytics/mParticle'
import Events from '../../../../../../lib/analytics/eventTags'
import content from 'pp-react-l10n'
import { PaymentTypes } from '../alt-pay-styles'
import { mediaQueries } from 'transfer/styles'
import glamorous from 'glamorous'
import personalSvg from '../../../icons/svg/personal.svg'
import glamorousIcon from '../../../../../../lib/glamorous-icon'
import PurchaseProtection from '../../purchaseProtectionLink'
import * as UnifiedActions from 'transfer/actions/unified-actions'
import { Radio, RadioGroup } from '@paypalcorp/pp-react-radio'
import { ActionTypes as types } from '../../../../../constants'
import { PAYMENT_TYPE, MONEY_PAGE } from '../../../../../../../../lib/constants'
import { redirectToDolphin } from '../../../../../actions/unified-actions'
import * as ViewActions from '../../../../../actions/Actions'
import { handleInterstitialCipFlow } from '../../../../../utils/homeInfoUtils'

const {
  phone5PortraitMax: phone320,
  phone6PortraitMax: phone375,
  phone6PlusPortraitMax: phone414,
} = mediaQueries
const i18nPaymentType = content('transfer/inc/paymentTypeChoices')
const PersonalIcon = glamorousIcon({
  display: 'inline-block',
  height: 48,
  width: 48,
  '& svg': {
    fill: '#0070BA',
    height: 48,
    width: 48,
  },
})
PersonalIcon.defaultProps = { svg: personalSvg }

const PaymentTypesToggle = glamorous(PaymentTypes)({
  ':focus': {
    outline: 'none',
  },
  textAlign: 'center',
  [phone414]: {
    margin: '-25px 0 0 0',
  },
  '& .protection-disclaimer': {
    textAlign: 'center',
  },
  '& h2': {
    fontFamily: 'PayPalSansBig-Light, sans-serif',
    fontSize: '24px',
    textAlign: 'left',
    color: '#2c2e2f',
    fontWeight: 600,
    padding: 0,
    margin: '0 auto',
    maxWidth: 360,
    [phone414]: {
      fontSize: 23,
    },
  },
  '& .canChooseWhoPays': {
    maxWidth: 360,
    display: 'inline-block',
    textAlign: 'left',
    marginLeft: '0 auto',
  },
  '& p, & aside, & .ppvx_radio-group': {
    maxWidth: 360,
    margin: '0 auto',
    color: '#2c2e2f',
    fontFamily: 'PayPalSansSmall-Regular, sans-serif',
    fontSize: 15,
    lineHeight: '1.5',
    textAlign: 'left',
    [phone320]: {
      fontSize: 14,
    },
  },
  '& .ppvx_radio-group': {
    marginTop: 9,
  },
  '& .ppvx_radio-group .ppvx_radio__label': {
    lineHeight: '1.3',
    [phone320]: {
      lineHeight: '1.2',
    },
  },
  '& aside': {
    marginTop: 16,
  },
  '& .sendBtn': {
    minWidth: 230,
    fontWeight: '700',
    marginTop: 19,
    [phone375]: {
      marginTop: 26,
    },
  },
})
const RecommendedBadge = glamorous.div({
  display: 'inline-block',
  backgroundColor: '#fff',
  border: '1px solid #018065',
  borderRadius: 4,
  color: '#018065',
  textTransform: 'uppercase',
  fontSize: 11,
  lineHeight: '15px',
  fontFamily: 'PayPalSansSmall-Regular, sans-serif',
  padding: '0 4px',
})
const PaymentChoiceBlock = glamorous.div({
  marginTop: 24,
  display: 'flex',
  justifyContent: 'center',
  '& .iconWrapper': {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 99,
    paddingTop: 7,
  },
  '& h3, & p': {
    width: '90%',
    fontSize: 15,
    lineHeight: '20px',
    fontFamily: 'PayPalSansSmall-Regular, sans-serif',
    textAlign: 'center',
    margin: '0 auto',
    padding: 0,
    [phone320]: {
      fontSize: 14,
    },
  },
  '& h3': {
    fontWeight: 600,
    width: '100%',
    margin: '-13px 0 6px 0',
    color: '#0070BA',
  },
  '& input': {
    opacity: 0,
    position: 'absolute',
    height: 0,
    width: 0,
  },
  '& .personal, & .purchase': {
    width: 171,
    minHeight: 172,
    border: '1px solid #0070BA',
    borderRadius: 10,
    [phone414]: {
      width: 155,
      minHeight: 173,
    },
    [phone320]: {
      width: 140,
      height: 152,
    },
  },
  // outline on focus for the accessibility
  '& .personalLabel input:focus ~ .personal, & .purchaseLabel input:focus ~ .purchase': {
    outline: 0,
    boxShadow: '0 0 0 3px rgba(0, 123, 255, .5)',
  },
  '& .personal': {
    marginRight: 10,
    [phone320]: {
      marginRight: 3,
    },
  },
  '& .purchase': {
    marginLeft: 10,
    [phone320]: {
      marginLeft: 3,
    },
    '& .ppvx_icon-cart': {
      color: '#0070BA',
      display: 'inline-block',
    },
  },
  '& .personalLabel input:checked ~ .personal': {
    backgroundColor: '#0070BA',
    '& h3, & p': {
      color: '#fff',
    },
    '& #personalIconSvg': {
      fill: '#fff',
    },
  },
  '& .purchaseLabel input:checked ~ .purchase': {
    backgroundColor: '#0070BA',
    '& h3, & p, & .ppvx_icon-cart': {
      color: '#fff',
    },
  },
})

export class PaymentTypeChoice extends React.Component {
  state = {
    highlightPaymentType: this.props.highlightPaymentType, // [PERSONAL|PURCHASE]
    // currently, we will have the recommended badge by default for the purchase option
    recommendedPaymentType: this.props.recommendedPaymentType, // [PERSONAL|PURCHASE]
    whoPaysFee: this.props.whoPaysFee, // ['sellerPaysFee'|'senderPaysFee']
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    flowType: PropTypes.string,
    handleClose: PropTypes.func,
    handleCloseForOtherFlow: PropTypes.func,
    isGuest: PropTypes.bool,
    hasSelectedFundingOption: PropTypes.bool,
    fee: PropTypes.string,
    whoPaysFee: PropTypes.string,
    overpanelType: PropTypes.string,
    highlightPaymentType: PropTypes.string,
    recommendedPaymentType: PropTypes.string,
    triggerSenderPhoneConfirmation: PropTypes.bool,
    amount: PropTypes.any,
    currencyCode: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    displayName: PropTypes.string,
    recipient: PropTypes.string,
    payerId: PropTypes.string,
    isPurchase: PropTypes.bool,
    suggestedDesign: PropTypes.string,
    moneyPageOverPanel: PropTypes.string,
    isPersonalDisabled: PropTypes.bool,
    isPurchaseDisabled: PropTypes.bool,
  }

  url = null
  targetFlowType = this.props.flowType

  // we route on unmount because if we route immediately after dispatching the action to close the overpanel,
  // it's too fast and the overpanel stays attached to the DOM.. so we let the overpanel unmounting do the routing
  componentWillUnmount() {
    // Redirect to Dolphin Flow After Payment Type Selection if the user has no confirmed phone and falls in the treatment
    const {
      triggerSenderPhoneConfirmation,
      amount,
      currencyCode,
      payerId,
      recipient,
      displayName,
      thumbnailUrl,
    } = this.props
    if (
      this.props.flowType !== 'payRequest' &&
      triggerSenderPhoneConfirmation
    ) {
      const flowType = this.targetFlowType
      const data = {
        flowType,
        amount,
        currencyCode,
        payerId,
        recipient,
        displayName,
        thumbnailUrl,
      }
      this.props.dispatch(redirectToDolphin(data))
    } else if (this.url && this.url !== 'payRequest') {
      routeTo(this.url)
    }
  }

  handleCloseForOtherFlow = targetFlowType => {
    let shouldUpdateTransactionData = false

    if (this.props.flowType === 'payRequest') {
      const preFlowType = this.props.isPurchase ? 'buy' : 'send'
      if (preFlowType !== targetFlowType) {
        shouldUpdateTransactionData = true
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      shouldUpdateTransactionData = true
      this.targetFlowType = targetFlowType
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL
            ? 'guestSelectFF'
            : 'guestSelectGS'
      } else {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL ? 'selectFF' : 'selectGS'
      }

      trackClickUnifiedSend(pageAction)

      this.props.dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: targetFlowType === PAYMENT_TYPE.PURCHASE,
          changedPurchaseProtection: true,
        })
      )
      if (this.props.isGuest) {
        trackGuestReturnToPagePmtChoice(pageAction)
      }
    }
    this.props.handleCloseForOtherFlow(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === PAYMENT_TYPE.PURCHASE,
    })
  }

  handlePaymentType = e => {
    this.setState({
      highlightPaymentType: e.target.value,
    })
  }

  handleFeeOption = e => {
    this.setState({
      whoPaysFee: e.target.value,
    })
    trackClickUnifiedSend(e.target.value)
    tracking(
      Events.p2p_payment_type_fee_payer_option_pressed({
        suggested_protection_design: this.props.suggestedDesign,
        fee_payer: e.target.value === 'sellerPaysFee' ? 'payee' : 'payer',
        protection_design: this.props.moneyPageOverPanel,
      })
    )
  }

  handleSubmit = e => {
    let targetFlowType =
      e.currentTarget.value === PAYMENT_TYPE.PURCHASE
        ? PAYMENT_TYPE.PURCHASE
        : PAYMENT_TYPE.PERSONAL
    let shouldUpdateTransactionData = false

    // the handleClose is closely coupled to send flow
    // this is hack for other flows so that we do not need to do the routing
    if (this.props.handleCloseForOtherFlow) {
      return this.handleCloseForOtherFlow(targetFlowType)
    }

    if (this.props.isPersonalDisabled && targetFlowType === 'PERSONAL') {
      return handleInterstitialCipFlow(
        targetFlowType === 'PURCHASE' ? 'buy' : 'send'
      )
    }
    if (this.props.isPurchaseDisabled && targetFlowType === 'PURCHASE') {
      return handleInterstitialCipFlow(
        targetFlowType === 'PURCHASE' ? 'buy' : 'send'
      )
    }

    const url =
      this.props.flowType !== 'payRequest'
        ? paymentTypeUrlMap[targetFlowType]
        : 'payRequest'

    if (this.props.flowType === 'payRequest') {
      const preFlowType = this.props.isPurchase ? 'buy' : 'send'
      if (preFlowType !== targetFlowType) {
        shouldUpdateTransactionData = true
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      this.url = url
      this.targetFlowType = targetFlowType
      shouldUpdateTransactionData = true
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL
            ? 'guestSelectFF'
            : 'guestSelectGS'
      } else {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL ? 'selectFF' : 'selectGS'
      }
      trackClickUnifiedSend(pageAction, {
        feePayer: this.state.whoPaysFee === 'sellerPaysFee' ? 'payee' : 'payer',
      })
    }

    this.props.dispatch({
      type: types.TRANSACTION.CHANGE_FEE_OPTION,
      data: {
        whoPaysFee: this.state.whoPaysFee,
      },
    })

    this.props.dispatch({
      type: types.TRANSACTION.CHANGE_HIGHLIGHTED_PAYMENT_TYPE,
      data: {
        highlightPaymentType: this.state.highlightPaymentType,
      },
    })

    this.props.dispatch(ViewActions.setPaymentTypeSelected(true))

    this.props.handleClose(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === PAYMENT_TYPE.PURCHASE,
    })
  }

  render() {
    const { overpanelType } = this.props
    const { highlightPaymentType, recommendedPaymentType } = this.state

    const isPersonalHighlighted = highlightPaymentType === PAYMENT_TYPE.PERSONAL
    const isPurchaseHighlighted = highlightPaymentType === PAYMENT_TYPE.PURCHASE
    const isSomethingHighlighted =
      isPersonalHighlighted || isPurchaseHighlighted

    const isT10 = overpanelType === MONEY_PAGE.BUYER_FEES_REC_DEFAULT_WEB
    const isT11 = overpanelType === MONEY_PAGE.TWO_BUTTON_NON_DEFAULT_WEB
    const canChooseWhoPays = isT10 && isPurchaseHighlighted

    const shouldShowNote = isSomethingHighlighted && !canChooseWhoPays
    let noteContent = i18nPaymentType('purchaseProtection.tPBNote')
    if (isPurchaseHighlighted) {
      noteContent = i18nPaymentType('purchaseProtection.tPBRadioSellerPays')
    } else if (isT11) {
      noteContent = i18nPaymentType('purchaseProtection.t11SendDescription')
    }

    return (
      <div data-nemo="t-parallel-buttons-variant">
        <PaymentTypesToggle tabIndex="-1">
          <h2>
            {i18nPaymentType(
              isT11
                ? 'purchaseProtection.t11Title'
                : 'purchaseProtection.tPBTitle'
            )}
          </h2>
          <PaymentChoiceBlock>
            <label className="personalLabel">
              <input
                type="radio"
                name="payment-type"
                data-testid="personal"
                value={PAYMENT_TYPE.PERSONAL}
                defaultChecked={isPersonalHighlighted}
                onChange={this.handlePaymentType}
              />
              <div className="personal">
                <div className="iconWrapper">
                  <RecommendedBadge
                    className={
                      recommendedPaymentType === PAYMENT_TYPE.PERSONAL
                        ? ''
                        : 'hide'
                    }
                  >
                    {i18nPaymentType('purchaseProtection.tPBRecommended')}
                  </RecommendedBadge>
                  <PersonalIcon />
                </div>
                <h3>{i18nPaymentType('purchaseProtection.tPBSendTitle')}</h3>
                <p>
                  {i18nPaymentType('purchaseProtection.tPBSendDescription')}
                </p>
              </div>
            </label>
            <label className="purchaseLabel">
              <input
                type="radio"
                name="payment-type"
                data-testid="purchase"
                value={PAYMENT_TYPE.PURCHASE}
                defaultChecked={isPurchaseHighlighted}
                onChange={this.handlePaymentType}
              />
              <div className="purchase">
                <div className="iconWrapper">
                  <RecommendedBadge
                    className={
                      recommendedPaymentType === PAYMENT_TYPE.PURCHASE
                        ? ''
                        : 'hide'
                    }
                  >
                    {i18nPaymentType('purchaseProtection.tPBRecommended')}
                  </RecommendedBadge>
                  <span className="ppvx_icon ppvx_icon--size_xl2 ppvx_icon-cart"></span>
                </div>
                <h3>{i18nPaymentType('purchaseProtection.tPBBuyTitle')}</h3>
                <p>{i18nPaymentType('purchaseProtection.tPBBuyDescription')}</p>
              </div>
            </label>
          </PaymentChoiceBlock>
          <div className={canChooseWhoPays ? 'canChooseWhoPays' : 'hide'}>
            <RadioGroup>
              <Radio
                label={i18nPaymentType('purchaseProtection.tPBRadioSellerPays')}
                value="sellerPaysFee"
                onChange={this.handleFeeOption}
                checked={this.state.whoPaysFee === 'sellerPaysFee'}
                data-testid="sellerPaysFee"
              />
              <Radio
                label={i18nPaymentType(
                  'purchaseProtection.tPBRadioSenderPays',
                  { protectionFee: this.props.fee }
                )}
                onChange={this.handleFeeOption}
                checked={this.state.whoPaysFee === 'senderPaysFee'}
                data-testid="senderPaysFee"
                value="senderPaysFee"
              />
            </RadioGroup>
          </div>
          <aside className={shouldShowNote ? '' : 'hide'}>{noteContent}</aside>
          <div className={isSomethingHighlighted ? '' : 'hide'}>
            <button
              onClick={this.handleSubmit}
              value={this.state.highlightPaymentType}
              className={'vx_btn sendBtn'}
              data-nemo="continue-btn"
            >
              {i18nPaymentType('main.continue')}
            </button>
            <p className="protection-disclaimer">
              <PurchaseProtection
                text={i18nPaymentType(
                  'purchaseProtection.protectionEligibility'
                )}
              />
            </p>
          </div>
        </PaymentTypesToggle>
      </div>
    )
  }
}

export default connect(({ server, transaction, recipient, amount, user }) => ({
  transaction: transaction.isPurchase,
  whoPaysFee: transaction.whoPaysFee,
  overpanelType: recipient.moneyPageOverPanel,
  highlightPaymentType: recipient.highlightPaymentType,
  recommendedPaymentType: recipient.recommendedPaymentType,
  triggerSenderPhoneConfirmation:
    server.triggerSenderPhoneConfirmation ||
    user.triggerSenderPhoneConfirmation,
  displayName: recipient.displayName,
  thumbnailUrl: recipient.thumbnailUrl,
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  recipient: recipient.recipient,
  payerId: recipient.payerId,
  isPurchase: transaction.isPurchase,
  moneyPageOverPanel: recipient.moneyPageOverPanel,
  suggestedDesign: recipient.suggestedDesign,
  isPersonalDisabled: user.isPersonalDisabled,
  isPurchaseDisabled: user.isPurchaseDisabled,
}))(PaymentTypeChoice)
